/* eslint-disable no-unused-vars */
/* eslint-disable no-promise-executor-return */
/* eslint-disable consistent-return */
/* eslint-disable no-console */

import { CacheSizeProvider } from "./CacheSizeProvider.js";

const humanReadableSize = (bytes) => {
  const thresh = 1024;
  let copyBytes = bytes;
  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }
  const units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let u = -1;
  do {
    copyBytes /= thresh;
    u += 1;
  } while (Math.abs(copyBytes) >= thresh && u < units.length - 1);
  return `${copyBytes.toFixed(1)} ${units[u]}`;
};

const calculateObjectSize = (storedObject) => {
  const json = JSON.stringify(storedObject);
  let size = json.length;

  const values = Object.values(storedObject);
  for (let i = 0; i < values.length; i += 1) {
    if (values[i] instanceof Blob) {
      size += values[i].size;
    }
  }
  return size;
};

const handleCursorSuccess = (event, state, resolve) => {
  const cursor = event.target.result;
  if (cursor) {
    state.DBSize += calculateObjectSize(cursor.value);
    cursor.continue();
  } else {
    resolve(state.DBSize);
  }
};

const getTableSize = (openedDBResult, tableName) => {
  return new Promise((resolve, reject) => {
    if (openedDBResult == null) {
      return reject();
    }

    const state = { DBSize: 0 };
    const transaction = openedDBResult
      .transaction([tableName])
      .objectStore(tableName)
      .openCursor();

    transaction.onsuccess = (event) => handleCursorSuccess(event, state, resolve);
    transaction.onerror = (err) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(`error in ${tableName}: ${err}`);
    };
  });
};

const processTableSizes = (sizes, DBName, cacheProvider) => {
  const total = sizes.reduce((acc, val) => acc + val, 0);
  const payload = {
    size: total,
    humanReadableFormat: humanReadableSize(total)
  };
  cacheProvider.setItem(DBName, payload);
};

const handleDBOpenError = () => {
  console.log("Why didn't you allow my web app to use IndexedDB");
};

const openDatabase = (DBName) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DBName);
    request.onerror = () => {
      handleDBOpenError();
      reject(new Error("Failed to open IndexedDB"));
    };
    request.onsuccess = (event) => resolve(event);
  });
};

const processDatabase = async (DBName, cacheProvider) => {
  try {
    const event = await openDatabase(DBName);
    const openedDBResult = event?.target?.result;
    const tableNames = openedDBResult?.objectStoreNames;
    const tableNamesArray = Array.from(tableNames);

    const tableSizeGetters = tableNamesArray.map(
      (tableName) => getTableSize(openedDBResult, tableName)
    );

    const sizes = await Promise.all(tableSizeGetters);
    processTableSizes(sizes, DBName, cacheProvider);
  } catch (error) {
    console.log(`Error processing database ${DBName}:`, error);
  }
};

export const calculateIndexedDBSize = async () => {
  const cacheProvider = CacheSizeProvider();
  const DBNames = ["TTFREVIEW"];

  await Promise.all(DBNames.map((DBName) => processDatabase(DBName, cacheProvider)));
};
